import { type NavigationTreeDataDTO } from "../api/getNavigationTree";
import { Link } from "../../common/components/Link";
import { Stacker } from "~/common/components/Stacker/Stacker";
import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";

interface Props {
  className?: string;
  navigation: NavigationTreeDataDTO[];
}

export const NotificationSettingsNavigation = ({ navigation, className }: Props) => {
  const { t } = useTranslation();

  navigation = navigation.filter((parent) => parent.parentType !== "ALL");
  return (
    <div className={className}>
      <Accordion expanded={true}>
        <AccordionSummary expandIcon={null} sx={{ pointerEvents: "none" }}>
          {t("notifications.filters.header.title")}
        </AccordionSummary>
        <AccordionDetails>
          <Stacker gap={16}>
            {navigation.map((item, i) => (
              <Link key={i} href={"#" + item.parentType}>
                {t(`${item.parentLabelTranslation}`)}
              </Link>
            ))}
          </Stacker>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
